import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orbitLOnboardingDetailKeys } from "Api/Queries/Merchants/useOrbitLOnboardingDetailQuery";
import {
  type TerminalActivationCodeDto,
  postMerchantsPublicIDOrbitLTidsTidReactivateCode,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  tid: string;
};

type Props = {
  onSuccess?: (result: TerminalActivationCodeDto) => void;
  onError?: () => void;
};

// Resets the device binding of a terminal that pairs by activation code (SoftPOS app, P300); the code stays and is READY again.
export const useReactivateTerminalActivationCodeMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID, tid }: Parameters) =>
        postMerchantsPublicIDOrbitLTidsTidReactivateCode(merchantPublicID, tid),
    ),
    onSuccess: (
      result: TerminalActivationCodeDto,
      { merchantPublicID }: Parameters,
    ) => {
      queryClient.invalidateQueries({
        queryKey:
          orbitLOnboardingDetailKeys.byMerchantPublicId(merchantPublicID),
      });
      onSuccess?.(result);
    },
    onError,
  });
};
